// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"faabc0fb","918":"40f82fdf"}[chunkId] + ".chunk.js";
};